import BaseComponent from './BaseComponent';

class BillingCheckbox extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    const input  = component.element.getElementsByTagName('input')[0];
    const target = document.querySelector(`label[data-checkbox-id='billing-checkbox']`);

    component.element.addEventListener('click', (e) => {
      e.preventDefault();

      // TOGGLE STATE
      if(!!input) {
        input.checked = input.checked ? false : true;
        input.checked ? this.lockSameAddressCheckbox(target, false) : this.lockSameAddressCheckbox(target, true);
      }

      app.components.form.submitData(input);
    });
  }


  lockSameAddressCheckbox(label, lock) {
    if(label.classList.contains('opened')) {
      app.components.accordion.toggleComponent(label);
    }

    const optionsWrapper = document.getElementsByClassName('addresses-options-wrapper')[0];
    if(lock) {
      label.classList.add('locked')
      app.components.accordion.lockContent(label, true);
      if(!!optionsWrapper) {
        optionsWrapper.style.height = 0 + 'px';
        optionsWrapper.classList.remove('visible');
      }
    } else {
      label.classList.remove('locked');
      app.components.accordion.lockContent(label, false);
      if(!!optionsWrapper) {
        optionsWrapper.style.height = optionsWrapper.scrollHeight + 'px';
        optionsWrapper.classList.add('visible');
      }
    }
  }
}

export default BillingCheckbox;
